import React from 'react'
import Question from './Question'
import Scroll from '../Scroll'

export default function Wiki() {
  return (
    <>
      <Scroll />
      <Question />
    </>
  )
}
